<template>
    <div class="form-container">
        <div class="form-register formResponsive">
            <span class="tit">Register</span><br><br>
            <p>Please register before submitting an article.</p>
            <div>
                <label class="inline">E-mail Address </label> <input class="inline" v-model="register.email" type="text" name=""/>
            </div>
            <div>
                <label class="inline">Create a Password </label> <input class="inline" v-model="register.password" type="password" name=""/>
            </div>
            <p>Your E-mail address and password will allow you to log in and view, edit or delete your submissions.
            You will receive an e-mail with the confirmation of your registration and password. </p><br>
            <input type="submit" value="Register" @click="validateRegister()"/><br><br>
            <p class="validation"> {{ registerValidation }} </p>
        </div>
    </div>
</template>

<script>
  export default {
      name: "Register",
  	  data () {
        return {
          register: {
            username: '',
            email: '',
            password: ''
          },
          registerValidation: '',
        }
      },
      methods: {
        validateRegister: function(value) {
          this.register.username = this.register.email;
          this.axios.post(process.env.API_BASE_URL + '/register', this.register).then(response => {
            if (response.data.error) {
                console.error(response.data.error);
                this.registerValidation = response.data.error;
            } else {
              this.$store.dispatch("login", response.data).then(() => {
                this.$emit("showFormChanged");
              });
            }
          });
        },
      }
  }
</script>


// WEBPACK FOOTER //
// Register.vue?111fac74